import { useEffect, useState } from 'react'
import { debounce } from 'lodash'

const getWidth = () => document.documentElement.clientWidth

/** The viewport width without the scrollbar, updated `wait` ms after the window stops resizing. */
export const useWindowWidth = (wait = 100): number => {
  const [width, setWidth] = useState(getWidth)

  useEffect(() => {
    const update = debounce(() => setWidth(getWidth()), wait)
    window.addEventListener('resize', update)
    window.addEventListener('orientationchange', update)
    return () => {
      update.cancel()
      window.removeEventListener('resize', update)
      window.removeEventListener('orientationchange', update)
    }
  }, [wait])

  return width
}
